import React from 'react'
import PropTypes from 'prop-types'

import { Form, Message, Modal } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './FeedbackModalContainer'
import Enhancer from './FeedbackModalEnhancer'

import Button from 'Components/StandardButton'
import FormInputDropdown from 'Components/FormInputDropdown'

import * as styles from './styles'
import { feedbackTypeOptions } from './options'

const FeedbackModal = props => {
  const {
    close,
    feedback,
    feedbackType,
    handleDropdownFeedbackTypeSelect,
    handleInputChange,
    handleSubmit,
    hasError,
    isPending,
    subject,
  } = props

  return (
    <Modal onClose={close} open={true}>
      <Modal.Header>Submit Feedback</Modal.Header>

      <Modal.Content>
        {hasError && <Message content="This wasn't supposed to happen. Please try again." header="An Error Occured." error />}

        <Form error={hasError} loading={isPending} onSubmit={handleSubmit}>
          <div>
            <Form.Field>
              <Form.Input name="subject" onChange={handleInputChange} placeholder="Subject" type="text" value={subject} required />
            </Form.Field>

            <FormInputDropdown
              multiple={false}
              name="feedbackType"
              onChange={handleDropdownFeedbackTypeSelect}
              options={feedbackTypeOptions}
              text="Feedback Type"
              value={feedbackType}
              hasNoLabel
            />

            <Form.Field>
              <Form.TextArea
                name="feedback"
                onChange={handleInputChange}
                placeholder="Send us your feedback & suggestions!"
                type="text"
                value={feedback}
              />
            </Form.Field>
          </div>

          <br />

          <div style={styles.alignRight}>
            <Button content="Send" disabled={!feedback || !feedbackType || !subject} icon="mail" pending={isPending} />
          </div>
        </Form>
      </Modal.Content>

      <Modal.Actions>
        <Button content="Close" error={hasError} icon={'x'} onClick={close} />
      </Modal.Actions>
    </Modal>
  )
}

FeedbackModal.propTypes = {
  close: PropTypes.func.isRequired,
  feedback: PropTypes.string.isRequired,
  feedbackType: PropTypes.string.isRequired,
  handleDropdownFeedbackTypeSelect: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  subject: PropTypes.string.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
)

export default composed(FeedbackModal)
